module.exports = __webpack_public_path__ + "d855313d22d44da703ed27c5967ae337.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/logo/logo.png
// module id = 660
// module chunks = 0